import { render, staticRenderFns } from "./gamepercentage.vue?vue&type=template&id=5b415ee1&scoped=true"
import script from "./gamepercentage.vue?vue&type=script&lang=js"
export * from "./gamepercentage.vue?vue&type=script&lang=js"
import style0 from "./gamepercentage.vue?vue&type=style&index=0&id=5b415ee1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b415ee1",
  null
  
)

export default component.exports